import React from "react";
import { Helmet } from "react-helmet";
import Oops from "../components/Oops";

const OopsPage = () => {
  return (
    <div>
      <Helmet>
        <title>Page not found</title>
      </Helmet>
      <Oops />
    </div>
  );
};

export default OopsPage;
